'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _isEmpty2 = require('lodash/isEmpty');

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

var _get3 = require('lodash/get');

var _get4 = _interopRequireDefault(_get3);

var _dec, _dec2, _dec3, _dec4, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRedux = require('react-redux');

var _project = require('redux/modules/project');

var projectActions = _interopRequireWildcard(_project);

var _reduxConnect = require('redux-connect');

var _reactI18next = require('react-i18next');

var _components = require('components');

var _reduxForm = require('redux-form');

var _reactRouter = require('react-router');

var _formComponents = require('components/formComponents');

var _reactRouterRedux = require('react-router-redux');

var _toastr = require('helpers/toastr');

var _toastr2 = _interopRequireDefault(_toastr);

var _asyncPromise = require('helpers/async-promise');

var _asyncPromise2 = _interopRequireDefault(_asyncPromise);

var _projects = require('selectors/projects');

var _SharespaceMediaList = require('./components/SharespaceMediaList');

var _SharespaceMediaList2 = _interopRequireDefault(_SharespaceMediaList);

var _SharespacePressList = require('./components/SharespacePressList');

var _SharespacePressList2 = _interopRequireDefault(_SharespacePressList);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var projectFormDefaults = {
  title: '',
  title2: '',
  internalRef: ''
};

var ProjectCreateFromSS = (_dec = (0, _reduxConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var dispatch = _ref.store.dispatch,
        projectId = _ref.params.projectId;
    var loadProject = projectActions.loadProject,
        loadMediaList = projectActions.loadMediaList,
        loadPressList = projectActions.loadPressList;

    var id = Number(projectId);
    var promises = [dispatch(loadProject(id)).promise.then(function () {
      return _promise2.default.all([dispatch(loadMediaList(id)).promise, dispatch(loadPressList(id)).promise]);
    })];
    return (0, _asyncPromise2.default)(_promise2.default.all(promises));
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state, ownProps) {
  var _ref2 = state.project.projectData || {},
      title = _ref2.title,
      title2 = _ref2.title2,
      internalRef = _ref2.internalRef;

  return {
    createSubprojectLoading: state.project.createSubprojectLoading,
    initialValues: state.project.projectData ? { title: title, title2: title2, internalRef: internalRef } : null,
    mediaList: state.project.mediaListData,
    mediaListLoading: state.project.mediaListLoading,
    partTracks: (0, _projects.getPartTracks)(state),
    pressList: state.project.pressListData,
    pressListLoading: state.project.pressListLoading,
    project: state.project.projectData,
    projectId: Number(ownProps.params.projectId),
    projectLoading: state.project.projectLoading,
    projectType: ownProps.params.type
  };
}, (0, _extends3.default)({}, projectActions, { pushState: _reactRouterRedux.push })), _dec3 = (0, _reduxForm.reduxForm)({
  form: 'projectForm',
  propNamespace: 'projectForm',
  initialValues: projectFormDefaults
}), _dec4 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(ProjectCreateFromSS, _Component);

  function ProjectCreateFromSS() {
    var _ref3;

    (0, _classCallCheck3.default)(this, ProjectCreateFromSS);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref3 = ProjectCreateFromSS.__proto__ || (0, _getPrototypeOf2.default)(ProjectCreateFromSS)).call.apply(_ref3, [this].concat(args)));

    _this.state = { checkedTracks: [], checkedPress: [] };
    return _this;
  }

  (0, _createClass3.default)(ProjectCreateFromSS, [{
    key: 'onTracksSelect',
    value: function onTracksSelect(checkedTracks) {
      this.setState({ checkedTracks: checkedTracks });
    }
  }, {
    key: 'onPressSelect',
    value: function onPressSelect(checkedPress) {
      this.setState({ checkedPress: checkedPress });
    }
  }, {
    key: 'isLocked',
    value: function isLocked() {
      var project = this.props.project || {};
      return !!project.isLocked;
    }
  }, {
    key: 'isTracksSelected',
    value: function isTracksSelected() {
      var mediaList = this.props.mediaList;
      var checkedTracks = this.state.checkedTracks;

      return !((0, _isEmpty3.default)(checkedTracks) && !(0, _isEmpty3.default)(mediaList) && !this.isLocked());
    }
  }, {
    key: 'submit',
    value: function submit(formData) {
      if (!this.isTracksSelected()) {
        return _toastr2.default.warning('No tracks selected');
      }

      var _props = this.props,
          t = _props.t,
          createSubproject = _props.createSubproject,
          projectId = _props.projectId,
          pushState = _props.pushState;
      var _state = this.state,
          checkedTracks = _state.checkedTracks,
          checkedPress = _state.checkedPress;

      var params = {
        projectId: projectId,
        data: formData,
        tracks: checkedTracks,
        press: checkedPress
      };

      createSubproject(params).promise.then(function (resp) {
        _toastr2.default.success(t('Project successfully created!'));

        var _get2 = (0, _get4.default)(resp, 'data.subProject', {}),
            id = _get2.id,
            contentType = _get2.contentType;

        return pushState('/projects/' + contentType + '/' + id);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          t = _props2.t,
          _props2$projectForm = _props2.projectForm,
          handleSubmit = _props2$projectForm.handleSubmit,
          submitting = _props2$projectForm.submitting,
          projectLoading = _props2.projectLoading,
          createSubprojectLoading = _props2.createSubprojectLoading,
          partTracks = _props2.partTracks,
          mediaList = _props2.mediaList,
          mediaListLoading = _props2.mediaListLoading,
          pressListLoading = _props2.pressListLoading,
          pressList = _props2.pressList;

      var project = this.props.project || {};
      var isLocked = this.isLocked();

      return _react2.default.createElement(
        'form',
        { onSubmit: handleSubmit(this.submit), className: 'page' },
        _react2.default.createElement(_reactHelmet2.default, { title: 'Project' }),
        _react2.default.createElement(
          'div',
          { className: 'container-fluid' },
          _react2.default.createElement(
            'h1',
            null,
            t('Create Project from Sharespace'),
            projectLoading && _react2.default.createElement(_components.Loader, { small: true, inline: true, right: true })
          ),
          _react2.default.createElement(
            'h3',
            null,
            t('Project name')
          ),
          _react2.default.createElement(
            'h4',
            null,
            t('Project'),
            ': ',
            project && project.artistName
          ),
          _react2.default.createElement(
            'div',
            { className: 'formRow' },
            _react2.default.createElement(
              'div',
              null,
              t('Title'),
              '*'
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(_reduxForm.Field, { name: 'title', noIndent: true, type: 'text', component: _formComponents.formSimpleTextInput, required: true, disabled: isLocked })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'formRow' },
            _react2.default.createElement(
              'div',
              null,
              t('Title'),
              ' 2'
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(_reduxForm.Field, { name: 'title2', noIndent: true, type: 'text', component: _formComponents.formSimpleTextInput })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'formRow' },
            _react2.default.createElement(
              'div',
              null,
              t('Internal Ref')
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(_reduxForm.Field, { name: 'internalRef', noIndent: true, type: 'text', component: _formComponents.formSimpleTextInput }),
              _react2.default.createElement(
                'div',
                null,
                t('This field allows you to identify this project. It will not be shown to any recipients')
              )
            )
          ),
          _react2.default.createElement(
            'h3',
            null,
            t('Music')
          ),
          _react2.default.createElement(_SharespaceMediaList2.default, {
            partTracks: partTracks,
            loading: mediaListLoading,
            mediaList: mediaList,
            project: project,
            onSelect: this.onTracksSelect
          }),
          project.id && _react2.default.createElement(
            'h3',
            null,
            t('Press list')
          ),
          _react2.default.createElement(_SharespacePressList2.default, {
            loading: pressListLoading,
            pressList: pressList,
            project: project,
            onSelect: this.onPressSelect
          }),
          _react2.default.createElement(
            'div',
            { className: 'text-right margin-vert-40' },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'btn btn-default wide', to: '/projects/sharespace' },
              t('Cancel')
            ),
            _react2.default.createElement(
              'button',
              { type: 'submit', className: 'btn btn-primary margin-left-10 wide pos-rel', disabled: submitting },
              t('Next'),
              createSubprojectLoading && _react2.default.createElement(_components.Loader, { mask: true })
            )
          )
        )
      );
    }
  }]);
  return ProjectCreateFromSS;
}(_react.Component), _class3.propTypes = {
  createSubproject: _propTypes2.default.func,
  createSubprojectLoading: _propTypes2.default.bool,
  mediaList: _propTypes2.default.array,
  mediaListLoading: _propTypes2.default.bool,
  partTracks: _propTypes2.default.object,
  pressList: _propTypes2.default.array,
  pressListLoading: _propTypes2.default.bool,
  project: _propTypes2.default.object,
  projectForm: _propTypes2.default.object,
  projectId: _propTypes2.default.number,
  projectLoading: _propTypes2.default.bool,
  pushState: _propTypes2.default.func,
  t: _propTypes2.default.func
}, _class3.defaultProps = {
  mediaList: [],
  project: {}
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onTracksSelect', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onTracksSelect'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onPressSelect', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onPressSelect'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'submit', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'submit'), _class2.prototype)), _class2)) || _class) || _class) || _class) || _class);
exports.default = ProjectCreateFromSS;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Project/ProjectCreate/ProjectCreateFromSS.js
// module id = 2190
// module chunks = 1